import * as React from 'react';
/**
 *
 * Original name: locked
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=20530%3A2416
 *
 */
export const LockedSync = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M12 4c-5.159 0-8 2.841-8 8s2.841 8 8 8 8-2.841 8-8-2.841-8-8-8Z", fill: "#8E8B87", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.813 10.167V9.036C9.813 7.723 10.588 7 12 7c1.41 0 2.188.723 2.188 2.036v1.13H15.5v4.977c0 .75-.588 1.357-1.313 1.357H9.814c-.725 0-1.313-.608-1.313-1.357v-4.976h1.313Zm1.312-1.131c0-.373.101-.475.13-.502.051-.047.24-.177.745-.177s.694.13.745.177c.029.027.13.13.13.502v1.13h-1.75v-1.13Z", fill: "#fff", vectorEffect: "non-scaling-stroke" })));
